import React, { FC, HTMLProps } from 'react'

export type NoticeVariant = 'danger' | 'info'

interface Props extends HTMLProps<HTMLDivElement> {
  variant: NoticeVariant
}

const Notice: FC<Props> = ({ variant, children, ...props }) => {
  return (
    <div {...props} className={`notice notice--${variant} ${props.onClick !== undefined ? 'cursor-pointer' : ''}`}>
      {children}
    </div>
  )
}

export default Notice
